import React, { useState } from "react";
import "./creativeBundle.css";
import emailjs from "emailjs-com";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const CreativeBundle = () => {
  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    mobile: "",
    email: "",
    inqueryType: "",
    details: "",
  });
  const [isSending, setIsSending] = useState(false);

  const isFormValid =
    formData.name &&
    formData.companyName &&
    formData.mobile &&
    formData.details &&
    formData.inqueryType &&
    formData.email;

  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    details: "",
  });

  const validateMobile = (mobile) => {
    const mobileRegex = /^[0-9]{11}$/;
    return mobileRegex.test(mobile);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, mobile, details, companyName, email, inqueryType } = formData;

    if (!validateMobile(mobile)) {
      setErrors({ ...errors, mobile: "Invalid mobile number" });
      return;
    }

    setIsSending(true);

    try {
      const emailData = {
        name,
        mobile,
        details,
        companyName,
        email,
        inqueryType,
      };

      console.log("EmailJS Data:", emailData);

      emailjs
        .send(
          "service_ukwpswk",
          "template_qaps4ud",
          emailData,
          "eustvQeLOCU86kDQW"
        )
        .then(
          (response) => {
            console.log("Message sent successfully:", response);
            setIsSending(false);
            setFormData({
              name: "",
              mobile: "",
              details: "",
              inqueryType: "",
              companyName: "",
              email: "",
            });
          },
          (error) => {
            console.error("Failed to send message:", error);
            setIsSending(false);
          }
        );
    } catch (error) {
      console.error("Error uploading files:", error);
      setIsSending(false);
    }
  };

  return (
    <section className="creative-bundle page">
      <div className="bundle-container">
        <div className="headline">
          <h1>
            The <span className="title-word">Creative Design</span> Bundle
          </h1>
          <p>Services &gt; Creative Design</p>
        </div>
        <div className="image-box">
          <LazyLoadImage
            src={require("../../../assets/blog-7.jpg")}
            alt="Creative Design Picture"
            effect="blur"
          />
        </div>
        <div className="desc">
          <p>
            Elevate your brand to new heights with our comprehensive design
            package, featuring
            <span className="desc-word"> Graphic Design </span>,
            <span className="desc-word"> Web Design </span>, and
            <span className="desc-word"> UI/UX Design </span> services tailored
            to meet your unique needs. Ideal for businesses and entrepreneurs
            looking to stand out, this package combines stunning visuals,
            intuitive interfaces, and strategic design to create an impactful
            digital presence. Whether you're aiming to boost engagement,
            increase conversions, or leave a lasting impression on your
            audience, our expert design solutions ensure your brand captures
            attention and drives results.
          </p>
          <p>
            Save up to <span className="desc-word"> 15 </span>% by choosing this
            bundle!
          </p>
        </div>
        <div className="form-container">
          <div className="form-left">
            <div className="text-box">
              <h1>
                Bring your vision to life! Fill in your
                <span className="title-word">Contact</span>
                details now, and let’s start elevating your brand!
              </h1>
            </div>
          </div>
          <div className="form-right">
            <form onSubmit={handleSubmit}>
              <div className="row-1">
                <div className="input-box">
                  <input
                    name="name"
                    type="text"
                    placeholder="Name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="input-box">
                  <input
                    name="companyName"
                    type="text"
                    placeholder="Company Name"
                    value={formData.companyName}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row-2">
                <div className="input-box">
                  <input
                    name="mobile"
                    type="text"
                    placeholder="Phone Number"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row-3">
                <div className="input-box">
                  <input
                    name="email"
                    type="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row-4">
                <select
                  name="inqueryType"
                  value={formData.inqueryType}
                  onChange={handleChange}
                >
                  <option value="">Inquiry Type</option>
                  <option value="UI/UX Design">UI/UX Design</option>
                  <option value="Graphic Design">Graphic Design</option>
                  <option value="SEO & SEM">SEO & SEM</option>
                  <option value="Video Editing">Video Editing</option>
                  <option value="Content Creation">Content Creation</option>
                  <option value="Social Media Management">
                    Social Media Management
                  </option>
                  <option value="Motion Graphics">Motion Graphics</option>
                  <option value="Paid Social Media Advertising">
                    Paid Social Media Advertising
                  </option>
                  <option value="Digital Marketing">Digital Marketing</option>
                  <option value="None of the above">None of the above</option>
                </select>
              </div>
              <div className="row-5">
                <div className="input-box">
                  <textarea
                    placeholder="Write your message here..."
                    name="details"
                    value={formData.details}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <button
                className="btn"
                type="submit"
                disabled={!isFormValid || isSending}
                style={{
                  opacity: isFormValid ? 1 : 0.5,
                  pointerEvents: isFormValid ? "auto" : "none",
                }}
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreativeBundle;
